export const HIDE_ALL_POPUPS = 'HIDE_ALL_POPUPS';
export const SHOW_PROJECT_PREFERENCES = 'SHOW_PROJECT_PREFERENCES';
export const HIDE_PROJECT_PREFERENCES = 'HIDE_PROJECT_PREFERENCES';

export default {};



// WEBPACK FOOTER //
// ../../src/popups/actionTypes.js